module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-attributes-set-wrapper"
    }
  }, [_c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('conjuntoAtributo.titulos.titulo'),
      "subTitle": _vm.$t('conjuntoAtributo.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('conjuntoAtributo.titulos.cadastroDeConjunto')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 row-filter-small",
    staticStyle: {
      "min-height": "83px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeSetName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.nomeDoConjunto'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.attributeSet.name),
      expression: "attributeSet.name"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('attributeSetName')
    },
    staticStyle: {
      "height": "36px !important"
    },
    attrs: {
      "type": "text",
      "id": "attributeSetName",
      "name": "attributeSetName",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.attributeSet.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributeSet, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attributeSetName')),
      expression: "errors.has('attributeSetName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-6 row-filter-small",
    staticStyle: {
      "min-height": "83px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "linkType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipoDeVinculo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('linkType')
    },
    attrs: {
      "options": _vm.attTypesAviable,
      "label": "description",
      "id": "linkType",
      "name": "linkType",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "disabled": this.attributeSetToEdit != null
    },
    model: {
      value: (_vm.attributeSet.linkType),
      callback: function($$v) {
        _vm.$set(_vm.attributeSet, "linkType", $$v)
      },
      expression: "attributeSet.linkType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linkType')),
      expression: "errors.has('linkType')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes && _vm.attributes.length > 0),
      expression: "attributes && attributes.length > 0"
    }],
    staticClass: "hint pull-left row-filter-medium"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.atributos'))
    }
  }), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.arrasteParaReordenar'))
    }
  })]), _c('div', {
    staticClass: "pull-right row-filter-medium"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('conjuntoAtributo.titulos.adicionarAtributo'),
      "id": "btnAbrirModalAdicionarAtributo",
      "clickFunction": _vm.createOrEditAttribute
    }
  })], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes && _vm.attributes.length > 0),
      expression: "attributes && attributes.length > 0"
    }],
    staticClass: "row-filter-small",
    attrs: {
      "id": "attributes-list"
    }
  }, [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-md-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.identificador'))
    }
  }), _c('div', {
    staticClass: "col-md-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.nome'))
    }
  }), _c('div', {
    staticClass: "col-md-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipo'))
    }
  }), _c('div', {
    staticClass: "col-md-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.valoresPossiveis'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-md-1"
  }, [_c('div', {
    staticClass: "categories-header-acoes-tit px-0 text-right",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _c('div', {
    staticClass: "attributes-list"
  }, [(_vm.attributes.length > 0) ? _c('draggable', {
    attrs: {
      "list": _vm.attributes
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.attributes), function(att, index) {
    return _c('attribute', {
      key: att.name,
      attrs: {
        "order": index + 1,
        "name": att.name,
        "description": att.description,
        "type": att.type,
        "possibleValues": att.possibleValues,
        "mask": att.mask,
        "validation": att.validation,
        "inUse": att.inUse,
        "handleEdit": _vm.createOrEditAttribute,
        "handleRemove": _vm.removeAttributeHandler
      }
    })
  }), 1)], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('conjuntoAtributo.labels.salvar'),
      "id": "btnSalvarConjuntoEstabelecimentos",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('conjuntoAtributo.labels.cancelar'),
      "id": "btnVoltarListagemAtributos",
      "customClass": "secondary",
      "clickFunction": _vm.backToList
    }
  })], 1)])])], 1)])]), (_vm.shown) ? _c('new-attribute-modal', {
    attrs: {
      "editingAttribute": _vm.editingAttribute,
      "attributesList": _vm.attributes
    },
    on: {
      "close-modal": function($event) {
        _vm.shown = false
      },
      "update-list-attributes": _vm.updateAttributesList
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7511b8fb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7511b8fb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/attributesSet/new.pug
// module id = 1439
// module chunks = 0